// @flow
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { AppLink } from '@finect/tabular-core/AppLink';

export const Card: any = styled.article`
  /* Evita que un token largo (ISIN, código de fondo, URL) ensanche la columna principal
     y le robe espacio al sidebar: replica el min-width:0 que usan el resto de tarjetas. */
  min-width: 0;
  overflow-wrap: anywhere;
  padding: 24px 0;
  border-top: 1px solid ${({ theme }) => theme.colors.uiM};

  &:first-of-type {
    border-top: none;
    padding-top: 6px;
  }
`;

export const Question: any = styled.p`
  ${getFont(0)};
  margin: 0 0 8px;
  color: ${({ theme }) => theme.colors.fontL};
`;

export const Label: any = styled.strong`
  margin-right: 6px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.font};
`;

export const QuestionLink: any = styled(AppLink)`
  font-weight: 600;
`;

export const AnswerLink: any = styled.a`
  display: block;
  margin: 0 0 12px;
  ${getFont(0, 'compact')};
  color: ${({ theme }) => theme.colors.font};
  text-decoration: none;
  transition: color 0.15s;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const PublishedAt: any = styled.small`
  ${getFont(-1)};
  color: ${({ theme }) => theme.colors.fontLL};
`;
